import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { LOGO } from "@/lib/assets";

export default function Footer() {
  return (
    <footer className="bg-obsidian text-cream relative grain" data-testid="footer">
      <div className="relative z-10 mx-auto max-w-[1500px] px-5 md:px-10 py-20">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-12">
          <div>
            <img src={LOGO} alt="HairPrive" className="h-28 w-auto object-contain -ml-1" style={{ filter: "brightness(0) invert(1)" }} />
            <p className="mt-5 font-sans font-light text-cream/60 text-sm max-w-xs leading-relaxed">
              The intersection of allopathic science and ayurvedic tradition — for
              healthier hair and scalp, ritual by ritual.
            </p>
            <div className="flex gap-5 mt-8">
              <a href="#" aria-label="Instagram" className="text-cream/60 hover:text-amber transition-colors"><Instagram className="w-5 h-5" strokeWidth={1.5} /></a>
              <a href="#" aria-label="Facebook" className="text-cream/60 hover:text-amber transition-colors"><Facebook className="w-5 h-5" strokeWidth={1.5} /></a>
              <a href="#" aria-label="Twitter" className="text-cream/60 hover:text-amber transition-colors"><Twitter className="w-5 h-5" strokeWidth={1.5} /></a>
            </div>
          </div>

          <FooterCol title="Explore" links={[["Shop", "/shop"], ["Consultation", "/consultation"], ["AI Analysis", "/analysis"], ["Journal", "/blog"]]} />
          <FooterCol title="Products" links={[["Argan Oil Serum", "/product/argan-oil-serum"], ["Hairgrow Serum", "/product/hairgrow-serum"], ["Dandruff Control", "/product/dandruff-control"]]} />
          <div>
            <h4 className="font-sans uppercase tracking-[0.2em] text-[11px] text-cream/50">Contact</h4>
            <ul className="mt-5 space-y-3 font-sans font-light text-sm text-cream/70">
              <li>hairpriveworld@gmail.com</li>
              <li>+91 99119 99347</li>
              <li>A5 - Gulmohar Park, August Kranti Marg,<br />New Delhi - 110049</li>
              <li>Mon–Sat · 10am–7pm</li>
              <li><Link to="/admin/login" className="link-underline text-cream/40 hover:text-amber">Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-4 font-sans text-[12px] text-cream/40">
          <span>© 2024 HairPrive. All rights reserved.</span>
          <span className="uppercase tracking-[0.2em]">Clinical · Herbal · Personal</span>
        </div>
      </div>
    </footer>
  );
}

const FooterCol = ({ title, links }) => (
  <div>
    <h4 className="font-sans uppercase tracking-[0.2em] text-[11px] text-cream/50">{title}</h4>
    <ul className="mt-5 space-y-3">
      {links.map(([label, to]) => (
        <li key={to}>
          <Link to={to} className="link-underline font-sans font-light text-sm text-cream/70 hover:text-cream">
            {label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);
